import { render, staticRenderFns } from "./CardMeasurement.vue?vue&type=template&id=04af45e2"
import script from "./CardMeasurement.vue?vue&type=script&lang=js"
export * from "./CardMeasurement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports